import { render, staticRenderFns } from "./CardWeeksTable.vue?vue&type=template&id=4da6acfe"
import script from "./CardWeeksTable.vue?vue&type=script&lang=js"
export * from "./CardWeeksTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports